<ul *ngIf="notifications && notifications.length > 0" class="jit-notifications">
  <jit-notification-item *ngFor="let item of notifications" [item]="item"></jit-notification-item>
</ul>